module.exports = __webpack_public_path__ + "static/media/A23.4bdf5b77.png";